// extracted by mini-css-extract-plugin
export default {"section":"contentsection_section__7i8Uk","image":"contentsection_image__lXE5N","imageWrapper":"contentsection_imageWrapper__v1pSd"};